import React, { useState } from 'react'
import Header from '../components/header/Header'
import FloatingButton from '../components/bottomtotop/FloatingButton'
import Footer from '../components/footer/Footer'
import { FaDatabase } from 'react-icons/fa6'
import { TbArtboard, TbChartHistogram, TbRouteSquare } from 'react-icons/tb'
import custom_img from '../../assets/images/custom_web_solution.png';
import scalable_img from '../../assets/images/scalable_imge.png';
import optimized_img from '../../assets/images/optimized_image.png';
import end_to_end_img from '../../assets/images/end_to_end_img.png'

const AboutUs = () => {
    const [activeAboutTab, setActiveAboutTab] = useState(1);
      const tabs = [
        {
          id: 1,
          title: 'Our Mission',
          content: (
            <>
              <p>
                At Selzor, our mission is to bridge the gap between technology and real-world challenges by delivering innovative, scalable, and client-centric digital solutions. We believe in unlocking potential through purposeful design, smart engineering, and a deep understanding of our clients' goals. Our team is driven by a passion to make technology more accessible, intuitive, and impactful — helping startups, enterprises, and individuals transform ideas into measurable success.
              </p>
              <p className="mt-4">
                We don’t just build products — we create ecosystems that drive growth, enhance user experiences, and lead industries toward a smarter, more connected future.
              </p>
              <ul className="block mt-6 space-y-2">
                <li className="flex items-start">
                  <span className="bg-white border border-[#E0E5EB] shadow-[0_8px_19px_rgba(13,40,38,0.15)] py-2 px-3 text-[#1a9588] font-semibold rounded-full mr-2">01</span>
                  Empower organizations to adapt and thrive in a constantly evolving digital landscape through bespoke, tech-forward solutions.
                </li>
                <li className="flex items-start">
                  <span className="bg-white border border-[#E0E5EB] shadow-[0_8px_19px_rgba(13,40,38,0.15)] py-2 px-3 text-[#1a9588] font-semibold rounded-full mr-2">02</span>
                  Establish long-term partnerships with clients by prioritizing integrity, transparency, and value at every stage of collaboration.
                </li>
              </ul>
              <div className="about-btn mt-8">
                <a
                  href="/about-us"
                  className="text-white bg-[#1a9588] hover:bg-[#28b5a6] hover:shadow-xl py-3 px-5 rounded-full"
                >
                  Learn More About Selzor
                </a>
              </div>
            </>
          ),
        },
        {
          id: 2,
          title: 'Our Vision',
          content: (
            <>
              <p>
                Selzor envisions a future where digital transformation is not a luxury, but a standard — available, efficient, and transformative for every business regardless of size. Our vision is to become a global innovation partner, recognized for delivering intelligent solutions that drive progress, sustainability, and long-term success.
              </p>
              <p className="mt-4">
                We aim to be more than a service provider — a trusted digital ally that understands your journey, anticipates challenges, and guides you through growth with confidence and clarity.
              </p>
              <ul className="block mt-6 space-y-2">
                <li className="flex items-start">
                  <span className="bg-white border border-[#E0E5EB] shadow-[0_8px_19px_rgba(13,40,38,0.15)] py-2 px-3 text-[#1a9588] font-semibold rounded-full mr-2">01</span>
                  Shape the future of digital ecosystems through continuous research, agile development, and cross-industry collaboration.
                </li>
                <li className="flex items-start">
                  <span className="bg-white border border-[#E0E5EB] shadow-[0_8px_19px_rgba(13,40,38,0.15)] py-2 px-3 text-[#1a9588] font-semibold rounded-full mr-2">02</span>
                  Inspire the next generation of entrepreneurs and businesses to lead confidently in the digital-first world.
                </li>
              </ul>
              <div className="about-btn mt-8">
                <a
                  href="/about-us"
                  className="text-white bg-[#1a9588] hover:bg-[#28b5a6] hover:shadow-xl py-3 px-5 rounded-full"
                >
                  Discover Our Vision
                </a>
              </div>
            </>
          ),
        },
        {
          id: 3,
          title: 'Our Goal',
          content: (
            <>
              <p>
                Our goal at Selzor is to drive measurable growth through intelligent technology. We aim to be the catalyst behind the success stories of our clients — by building powerful platforms, optimizing digital performance, and delivering solutions that are as practical as they are visionary.
              </p>
              <p className="mt-4">
                Every product we develop and every strategy we execute is rooted in one belief: technology should solve real problems, create real impact, and make life better — for businesses, users, and the communities they serve.
              </p>
              <ul className="block mt-6 space-y-2">
                <li className="flex items-start">
                  <span className="bg-white border border-[#E0E5EB] shadow-[0_8px_19px_rgba(13,40,38,0.15)] py-2 px-3 text-[#1a9588] font-semibold rounded-full mr-2">01</span>
                  Deliver high-performance digital solutions that meet today's needs and scale for tomorrow’s opportunities.
                </li>
                <li className="flex items-start">
                  <span className="bg-white border border-[#E0E5EB] shadow-[0_8px_19px_rgba(13,40,38,0.15)] py-2 px-3 text-[#1a9588] font-semibold rounded-full mr-2">02</span>
                  Continuously elevate customer satisfaction by delivering exceptional user experiences and measurable results.
                </li>
              </ul>
              <div className="about-btn mt-8">
                <a
                  href="/about-us"
                  className="text-white bg-[#1a9588] hover:bg-[#28b5a6] hover:shadow-xl py-3 px-5 rounded-full"
                >
                  Explore Our Goals
                </a>
              </div>
            </>
          ),
        },
      ];

      const blogPosts = [
        {
          id: 1,
          title: "Why Selzor is the Go-To Choice for Website Development",
          date: "01 Aug 2025",
          readTime: "6 Min Read",
          image: "https://tailwind.saasable.io/assets/images/blog/blog13.jpg",
          large: true,
        },
        {
          id: 2,
          title: "Top Features of Selzor That Empower Your Online Presence",
          date: "03 Aug 2025",
          readTime: "7 Min Read",
          image: "https://tailwind.saasable.io/assets/images/blog/blog14.jpg",
          large: false,
        },
        {
          id: 3,
          title: "How Selzor Transforms Ideas into Stunning Digital Solutions",
          date: "05 Aug 2025",
          readTime: "9 Min Read",
          image: "https://tailwind.saasable.io/assets/images/blog/blog15.jpg",
          large: false,
        },
      ];

      const [activefeaturesTab, setActivefeaturesTab] = useState('2');
      const features = [ 
        {
          id: '1',
          title: 'Custom Web Solutions',
          icon: <TbArtboard />,
          description: 'We craft custom websites that align with your brand, goals, and business needs—no templates, just innovation.',
          image: custom_img,
        },
        {
          id: '2',
          title: 'Scalable Architecture',
          icon: <FaDatabase />,
          description: 'Our websites are built to grow with you—from startups to enterprises, Selzor ensures seamless scalability as your traffic and needs increase.',
          image: scalable_img,
        },
        {
          id: '3',
          title: 'Optimized Performance',
          icon: <TbRouteSquare />,
          description: 'Every website we build is optimized for speed, mobile responsiveness, and user experience to keep visitors engaged and conversions high.',
          image: optimized_img,
        },
        {
          id: '4',
          title: 'End-to-End Security',
          icon: <TbChartHistogram />,
          description: 'From SSL integration to secure code practices, we implement robust security features to protect your data and build user trust.',
          image: end_to_end_img,
        },
      ];


  return (
    <div>
        <Header />
         <section className="pb-20 pt-20">
              <div className="max-w-7xl mx-auto px-4">
                <div className="flex flex-wrap">
                  <div className="lg:w-1/2 w-full">
                    <div className="relative max-w-[592px] w-full h-[594px]">
                      <div className="absolute top-[0] left-[0] max-w-[490px] w-full h-[467px]">
                        <img
                          src="https://html.rrdevs.net/edcare/assets/img/new-update-2/about-img-1.png"
                          alt="about-1"
                          className="w-full h-full overflow-hidden rounded-[20px]"
                        />
                      </div>
                      <div className="absolute bottom-[0] right-[0] max-w-[363px] w-full h-[375px] rounded-tl-[200px] rounded-br-[20px] rounded-tr-[200px] rounded-bl-[20px] border-[5px] border-[solid] border-[#ffffff] overflow-hidden [box-shadow:0px_4px_35px_rgba(10,_27,_25,_0.28)]">
                        <img
                          src="https://html.rrdevs.net/edcare/assets/img/new-update-2/about-img-2.png"
                          alt="about-2"
                          className="w-full h-auto"
                        />
                      </div>
                    </div>
                  </div>
        
                  <div className="lg:w-1/2 w-full">
                    <div className="mt-8 lg:mt-0 md:mt-0">
                      <div className="mb-8">
                        <h4 className="text-xl text-start font-semibold">
                          <span className="text-2xl xs:text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-1 sm:mb-2 lg:mb-3">About Company</span>
                        </h4>
                        <h2 className="text-gray-600 text-sm xs:text-base sm:text-lg mb-6 sm:mb-8 lg:mb-10 text-start mt-4">
                          The Ultimate Online Platform for Interactive and Personalized Learning
                        </h2>
                      </div>
        
                      <div className="mt-8">
                        <ul className="flex space-x-2">
                          {tabs.map((tab) => (
                            <li key={tab.id}>
                              <button
                                className={`border py-1.5 px-5 rounded-full font-semibold ${
                                  activeAboutTab === tab.id ? 'text-white bg-[#1a9588]' : 'text-gray-700'
                                }`}
                                onClick={() => setActiveAboutTab(tab.id)}
                              >
                                {tab.title}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
        
                      <div className="tab-content mt-8">
                        {tabs
                          .filter((tab) => tab.id === activeAboutTab)
                          .map((tab) => (
                            <div key={tab.id} className="tab-pane [transition:opacity_.15s_linear] text-start">
                              {tab.content}
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
         </section>

            {/* <section className="pb-8 sm:pb-12 md:pb-16 lg:pb-20">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        {}
                        <div className='text-start mb-4 sm:mb-6'>
                        <h2 className="text-2xl xs:text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-1 sm:mb-2 md:mb-3">
                            Resource Center
                        </h2>
                        <p className="text-gray-600 text-sm sm:text-base md:text-lg">
                             Explore how Selzor delivers cutting-edge web solutions, expert design, and performance that builds trust and drives growth.
                        </p>
                        </div>
            
                        {}
                        <div className="grid grid-cols-12 gap-3 sm:gap-4">
                        {}
                        <div className="col-span-12 sm:col-span-5">
                            <div className="bg-[#dbf4f1] rounded-2xl sm:rounded-[24px] overflow-hidden h-full flex flex-col">
                            <div
                                className="h-[180px] xs:h-[200px] sm:h-[180px] md:h-[220px] lg:h-[280px] xl:h-[326px] bg-cover bg-center rounded-b-2xl sm:rounded-b-3xl"
                                style={{
                                backgroundImage: `url(${blogPosts[0].image})`,
                                }}
                            />
                            <div className="p-4 sm:p-5 md:p-6 lg:p-8 flex flex-col gap-2 sm:gap-3">
                                <p className="text-xs font-semibold text-start text-gray-500 whitespace-nowrap">
                                {blogPosts[0].date} · {blogPosts[0].readTime}
                                </p>
                                <a
                                href="/"
                                className="group flex justify-between items-start text-black hover:text-[#1a9588]"
                                >
                                <h3 className="font-normal text-xl sm:text-2xl lg:text-3xl text-start line-clamp-2 group-hover:text-[#1a9588]">
                                    {blogPosts[0].title}
                                </h3>
                                <span className="text-lg sm:text-xl leading-none"><FaArrowRightLong className="-rotate-45" /></span>
                                </a>
                            </div>
                            </div>
                        </div>
            
                        {}
                        <div className="col-span-12 sm:col-span-7 flex flex-col gap-3 sm:gap-4">
                            {blogPosts.slice(1).map((post) => (
                            <div
                                key={post.id}
                                className="bg-[#dbf4f1] rounded-2xl sm:rounded-[24px] overflow-hidden"
                            >
                                <div className="flex min-h-[100px] xs:min-h-[116px] sm:min-h-[140px] md:min-h-[160px] lg:min-h-[174px]">
                                <div
                                    className="min-w-[80px] xs:min-w-[100px] sm:min-w-[120px] md:min-w-[140px] lg:min-w-[160px] xl:min-w-[174px] bg-cover bg-center rounded-2xl sm:rounded-[24px]"
                                    style={{ backgroundImage: `url(${post.image})` }}
                                />
                                <div className="flex flex-col justify-between p-3 sm:p-4 md:p-5 lg:p-6 w-full">
                                    <p className="text-xs font-semibold text-start text-gray-500 whitespace-nowrap">
                                    {post.date} · {post.readTime}
                                    </p>
                                    <a
                                    href="/"
                                    className="group flex justify-between items-center hover:text-[#1a9588]"
                                    >
                                    <h4 className="font-normal text-xl sm:text-2xl lg:text-3xl text-start group-hover:text-[#1a9588]">
                                        {post.title}
                                    </h4>
                                    <span className="text-lg sm:text-xl leading-none"><FaArrowRightLong className="-rotate-45" /></span>
                                    </a>
                                </div>
                                </div>
                            </div>
                            ))}
            
                            {}
                            <a
                            href="/"
                            className="hidden lg:flex justify-center items-center gap-2 text-[#1a9588] font-medium bg-[#dbf4f1] rounded-[24px] px-6 py-4 hover:bg-[#b9ece6] transition text-base sm:text-lg"
                            >
                            View All
                            <span className="text-lg"><FaArrowRightLong /></span>
                            </a>
                        </div>
            
                        {}
                        <div className="col-span-12 lg:hidden">
                            <a
                            href="/"
                            className="flex justify-center items-center gap-2 text-[#1a9588] font-medium bg-[#dbf4f1] rounded-2xl sm:rounded-[24px] px-4 py-3 sm:px-6 sm:py-4 hover:bg-[#b9ece6] transition text-sm sm:text-base"
                            >
                            View All
                            <span className="text-base sm:text-lg"><FaArrowRightLong /></span>
                            </a>
                        </div>
                        </div>
                    </div>
            </section> */}

          <section>
            <div className="max-w-7xl mx-auto px-4 py-10">
                <div className="flex flex-col gap-6 sm:gap-10">
                <div className='text-start'>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-700 mb-2 sm:mb-3">
                Why Choose Selzor?
                </h2>
                <p className="text-gray-600 text-base sm:text-lg">
                  At Selzor, we don’t just build websites — we build digital experiences that grow with your business. From performance and scalability to security and personalization, our solutions are designed to deliver long-term value and reliability.
                </p>
              </div>

                <div className="flex flex-col sm:flex-row gap-3 items-center">
                    <div className="h-full basis-full sm:basis-1/2">
                    <ul className="flex flex-col w-full">
                        {features.map((item) => (
                        <li key={item.id} className={`group grow ${activefeaturesTab === item.id ? 'border-l-2 border-[#1a9588]' : 'border-l-2 border-gray-200'}`}>
                            <button
                            onClick={() => setActivefeaturesTab(item.id)}
                            className="w-full text-left p-4 sm:p-6 hover:bg-[#F4FBF8] transition-all duration-150 ease-linear"
                            >
                            <div className="flex items-start gap-3 sm:gap-4">
                                <div className="w-[60px] h-[60px] bg-[#dbf4f1] rounded-2xl flex items-center justify-center shrink-0">
                                <span className= 'text-2xl text-[#1a9588]'>{item.icon}</span>
                                </div>
                                <div className="flex flex-col gap-2 grow mb-6">
                                <h4 className="text-2xl">{item.title}</h4>
                                <p className="text-gray-600 max-w-[350px]">{item.description}</p>
                                </div>
                            </div>
                            </button>
                        </li>
                        ))}
                    </ul>
                    </div>

                    {/* Tab Image Preview */}
                    <div className="max-sm:w-full basis-full sm:basis-1/2">
                    <div className="p-6 md:p-0 w-full h-[358px] sm:h-[536px] md:h-[700px] bg-[#dbf4f1] rounded-3xl sm:rounded-[32px] md:rounded-[40px] overflow-hidden relative">
                        <div className="h-full bg-center bg-contain bg-no-repeat"
                        style={{ backgroundImage: `url(${features.find(item => item.id === activefeaturesTab)?.image})` }}
                        ></div>
                    </div>
                    </div>
                </div>

                </div>
            </div>
        </section>
        <FloatingButton />
        <Footer />
    </div>
  )
}

export default AboutUs